import React, { useEffect, useState } from "react";
import { useSocket } from "../../core/context/SocketContext";
import { Toast, ToastContainer } from "./Toast";

interface Notification {
  id: string;
  title: string;
  message: string;
}

const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { socket } = useSocket();
  const [toasts, setToasts] = useState<Notification[]>([]);

  // Preload audio once
  const audio = React.useRef<HTMLAudioElement>(new Audio("/sounds/notification.mp3"));

  
  useEffect(() => {
    if (!socket) return;

    const handleNotification = (notif: { title: string; message: string }) => {
      const id = Date.now().toString();
      const newNotif = { ...notif, id };

      // Play sound when notification appears
      const audio = new Audio("/sounds/notification.mp3");
      audio.play().catch(() => {
        // ignore if user hasn't interacted yet
      });

      // Add toast to state
      setToasts((prev) => [...prev, newNotif]);

      // Auto-remove after 5.5 seconds
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 5500);
    };

    socket.on("notification", handleNotification);

    return () => {
      socket.off("notification", handleNotification);
    };
  }, [socket]);

  return (
    <>
      {children}
      <ToastContainer>
        {toasts.map((t) => (
          <Toast
            key={t.id}
            title={t.title}
            message={t.message}
            onClose={() => setToasts((prev) => prev.filter((n) => n.id !== t.id))}
          />
        ))}
      </ToastContainer>
    </>
  );
};

export default NotificationProvider;
